<template>
  <StoreCartSection>
    <div class="dark:bg-gray-900">
      <p class="p-4 text-xs text-warning-500 whitespace-pre-line">{{ note }}</p>
    </div>
  </StoreCartSection>
</template>

<script>
export default {
  props: {
    note: { type: String, default: null },
  },
};
</script>
